import React from 'react';
import { useState, useEffect, useRef } from 'react';
import './dashboarder_inner_main.scss';
import { nxtdash_install_plugin  } from '../../apicall';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { decode } from 'html-entities';

import { __ } from '@wordpress/i18n';

var plugin_url = nxtext_ajax_object.nxtex_url;

var ratingSvg = [
    {
        svg : <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30"><path fill="#C9C7CE" fillRule="evenodd" d="m17.208 7.611 1.808 2.51 2.5.774c3.096.956 3.837 1.346 3.837 2.02 0 .29-.884 1.51-1.965 2.71l-1.965 2.182.204 3.308c.273 4.441.273 4.442-3.856 3.108l-3.095-1-3.095 1c-4.128 1.334-4.129 1.333-3.855-3.108l.204-3.308-1.965-2.182C4.885 14.425 4 13.194 4 12.888c0-.635 1.472-1.362 4.375-2.164 1.822-.504 1.888-.558 3.791-3.162 1.547-2.114 2.068-2.63 2.586-2.555.421.06 1.285.976 2.456 2.604Zm-5.365 6.56c-.306.495.382 1.062.79.653.343-.342.129-.975-.33-.975-.143 0-.35.145-.46.322Zm4.745 0c-.306.495.382 1.062.79.653.343-.342.129-.975-.33-.975-.143 0-.35.145-.46.322Zm-3.32 3.005c-.367.177-.668.45-.668.605 0 .163.22.182.52.044.285-.132.985-.24 1.556-.24.571 0 1.272.108 1.557.24.297.137.52.12.52-.041 0-.38-1.357-.974-2.165-.95-.36.012-.953.166-1.32.342Z" clipRule="evenodd"/></svg>
    },
    {
        svg : <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30"><path fill="#C9C7CE" fillRule="evenodd" d="M17.15 7.619c1.92 2.616 1.924 2.62 4.075 3.292 2.852.892 3.781 1.39 3.781 2.03 0 .292-.877 1.503-1.948 2.693l-1.948 2.163.203 3.304c.27 4.39.27 4.389-3.682 3.093l-2.966-.972-3.094 1c-4.127 1.334-4.127 1.334-3.854-3.098l.203-3.3-1.96-2.177C4.882 14.451 4 13.233 4 12.941c0-.654.987-1.177 3.81-2.015 2.397-.712 2.784-1.026 4.842-3.94C13.578 5.676 14.256 5 14.642 5c.394 0 1.212.854 2.507 2.619Zm-5.326 6.578c-.304.494.381 1.06.79.651.34-.341.127-.972-.33-.972-.143 0-.35.144-.46.321Zm4.734 0c-.305.494.38 1.06.79.651.34-.341.127-.972-.33-.972-.144 0-.35.144-.46.321Z" clipRule="evenodd"/></svg>
    },
    {
        svg : <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30"><path fill="#C9C7CE" fillRule="evenodd" d="M13.57 5.88c-.406.549-1.286 1.752-1.955 2.674-1.1 1.517-1.399 1.73-3.134 2.243C5.299 11.74 4 12.375 4 12.993c0 .307.898 1.556 1.996 2.774l1.995 2.216-.208 3.212c-.282 4.35-.259 4.367 3.926 3.015l3.146-1.017 3.147 1.017c4.194 1.355 4.223 1.333 3.938-3.027l-.21-3.212 1.99-2.21c1.095-1.215 1.99-2.451 1.99-2.747 0-.685-.752-1.082-3.905-2.056l-2.549-.787-1.844-2.552C15.28 4.671 14.67 4.395 13.57 5.88Zm-.658 8.412c.31.503-.388 1.08-.805.663-.348-.348-.13-.991.336-.991.146 0 .357.147.469.328Zm4.824 0c.31.503-.388 1.08-.804.663-.348-.348-.13-.991.336-.991.146 0 .357.147.468.328Zm-1.071 2.989c0 .167-.804.301-1.81.301-1.005 0-1.809-.134-1.809-.301 0-.168.804-.302 1.81-.302 1.005 0 1.809.134 1.809.302Z" clipRule="evenodd"/></svg>
    },
    {
        svg : <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30"><path fill="#C9C7CE" fillRule="evenodd" d="m12.162 7.543-1.93 2.628-2.763.827c-1.519.454-2.929.964-3.133 1.133-.701.58-.366 1.316 1.59 3.488l1.96 2.176-.206 3.307c-.278 4.452-.272 4.458 3.867 3.12l3.095-1 3.096 1c4.129 1.334 4.13 1.334 3.855-3.108l-.203-3.309 1.965-2.182c1.08-1.2 1.965-2.419 1.965-2.71 0-.67-.68-1.027-3.812-2l-2.527-.783-1.82-2.516c-1.133-1.568-2.054-2.55-2.444-2.608-.49-.072-1.049.483-2.556 2.537Zm.569 6.627c.305.495-.382 1.062-.791.652-.343-.342-.128-.975.33-.975.144 0 .35.146.46.323Zm4.745 0c.306.495-.382 1.062-.79.652-.343-.342-.129-.975.33-.975.143 0 .35.146.46.323Zm-3.09 3.159c.43.074 1.056-.012 1.39-.191.336-.18.68-.212.767-.072.187.302-1.098.934-1.9.934-.754 0-2.077-.618-2.077-.97 0-.154.234-.18.52-.058.285.122.87.283 1.3.357Z" clipRule="evenodd"/></svg>
    },
    {
        svg : <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30"><path fill="#C9C7CE" fillRule="evenodd" d="M15.61 5.707c.319.37 1.23 1.536 2.027 2.59 1.438 1.904 1.469 1.925 4.584 2.996 2.096.72 3.168 1.241 3.229 1.569.05.27-.8 1.507-1.887 2.75l-1.978 2.258.359 3.187c.5 4.446.47 4.47-3.873 3.16l-3.273-.986-2.874.958c-4.115 1.37-4.086 1.392-4.086-3.04v-3.613l-1.965-2.082C4.74 14.25 3.95 13.16 4.003 12.872c.063-.34 1.098-.846 3.226-1.578l3.132-1.077 1.444-2.068c2.455-3.516 2.73-3.693 3.805-2.442Zm-4.03 8.314c-.625.69-.39 1.171.294.603.368-.306.545-.306.913 0 .685.568.92.087.294-.603-.299-.33-.636-.601-.75-.601-.114 0-.452.27-.75.6Zm5.092 0c-.625.69-.39 1.171.294.603.365-.303.547-.304.906-.006.608.504.59-.117-.021-.728-.584-.584-.526-.59-1.179.13Zm-3.443 3.096c0 .573.99 1.395 1.68 1.395.767 0 1.915-.818 1.915-1.365 0-.329-.43-.432-1.797-.432-1.306 0-1.798.11-1.798.402Z" clipRule="evenodd"/></svg>
    },
]

const DashboardInnerMain = () => {
    // --------- What's New Button On cick Function Start------------- // 
    var openSidebar = nxtext_ajax_object?.dashData?.showSidebar || false;
    const [slideLeft, setSlideLeft] = useState(openSidebar);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    //what's new
    const [items, setItems] = useState([]);
    //const [offset, setOffset] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const scrollRef = useRef(null);

    const validateEmail = (email) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.[^<>()[\]\\.,;:\s@"]{2,}))$/i;
        return re.test(String(email).toLowerCase());
    };

    useEffect(() => {

        const handleClickOutside = (event) => {
            if ( !event.target.closest('.nxtext_whats_new ') && !event.target.closest('.nxt_whats_new_box_opened') ) {
                setSlideLeft(false)
            }
        };

        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                setSlideLeft(false)
            }
        };

        document.addEventListener('keydown', handleEscapeKey);
        document.body.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
            document.body.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const [hoveredIndex, setHoveredIndex] = useState(5);
    const [selectedIndex, setSelectedIndex] = useState(null);

    useEffect(() => {
        const stars = document.querySelectorAll('.nxt-star path');
         stars.forEach((star, index) => {
            if (selectedIndex !== null && index <= selectedIndex) {
                star.setAttribute('fill', '#F9B744');
            } else if (hoveredIndex !== null && index <= hoveredIndex) {
                star.setAttribute('fill', '#F9B744');
            } else {
                star.setAttribute('fill', '#C9C7CE');
            }
        });
    }, [hoveredIndex, selectedIndex]);

    const handleSubscribe = async () => {
        if (!name || !email) {
            setError(__('Please provide your email & name.', 'nexter-extension'));
            return;
        }
        if (!validateEmail(email)) {
            setError(__('Please enter a valid email.', 'nexter-extension'));
            return;
        }
    
        setError('');
        setSuccess('');
    
        // URL encode the name and email
        const encodedName = encodeURIComponent(name);
        const encodedEmail = encodeURIComponent(email);
    
        // Append the encoded values to the URL
        const welcomeEmailUrl = `https://store.posimyth.com/?fluentcrm=1&route=contact&hash=30275c78-0cf5-42f1-adb0-32901bb25b90&full_name=${encodedName}&email=${encodedEmail}`;
    
        try {
            const response = await fetch(welcomeEmailUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin' : 'http://localhost/',
                },
                mode: 'no-cors',
            });
           
            if (response) {
                setSuccess(__('Success! You’ve been added to our email list.', 'nexter-extension'));

                setTimeout(() => {
                    setSuccess('');
                    setName('');
                    setEmail('');
                }, 2500);


            } else {
                setError(__('Subscription failed. Please try again later.', 'nexter-extension'));
            }
        } catch (error) {
            console.error('Error during subscription:', error);
            setError(__('Subscription failed. Please try again later.', 'nexter-extension'));
        }
    };

    const installNxtPlugin = (e, slug) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('action', 'nexter_ext_plugin_install');
        formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);
        formData.append('slug', slug);
        
        nxtdash_install_plugin(e, formData, slug, '', 'welcome');
    }

    // --------- What's New Button On cick Function End------------- // 

    const icons = [
        { name: 'facebook', path: 'assets/svg/dashboard_tab/facebook.svg' , link : 'https://www.facebook.com/nexterwp' },
        { name: 'x_icon', path: 'assets/svg/dashboard_tab/xicon.svg' , link : 'https://x.com/intent/user?screen_name=nexterwp' },
        { name: 'insta', path: 'assets/svg/dashboard_tab/insta.svg' , link : 'https://www.instagram.com/nexterwp/' },
        { name: 'telegram', path: 'assets/svg/dashboard_tab/telegram.svg' , link : 'https://t.me/posimyth' },
        { name: 'linkedin', path: 'assets/svg/dashboard_tab/linkedin.svg' , link : 'https://linkedin.com/company/posimyth' }
    ];

    const slides = [
        {   
            key : 'wdesignkit',
            heading: __('Get 1000+ Pre-Designed', 'nexter-extension'),
            subheading: __('WordPress Pages & Templates.', 'nexter-extension'),
            buttonLabel: __('Enable Templates', 'nexter-extension'),
            buttonLinkLabel: __('Open Templates', 'nexter-extension'),
            learnLink: 'https://wdesignkit.com/?utm_source=wpbackend&utm_medium=nexter-extension&utm_campaign=nextersettings',
            imgSrc: plugin_url + 'assets/images/wdesinKit.png',
            imgAlt: 'WDesignKit Image',
            browseLink: '?page=wdesign-kit#/browse',
            wdadded: nxtext_ajax_object.dashData.wdkPlugin || nxtext_ajax_object.dashData.wdadded,
        },
        {
            key : 'uichemy',
            heading: __('Convert Figma to WordPress', 'nexter-extension'),
            subheading: __('in Minutes', 'nexter-extension'),
            buttonLabel: __('Install UiChemy', 'nexter-extension'),
            buttonLinkLabel: __('UiChemy Setting', 'nexter-extension'),
            learnLink: 'https://uichemy.com/?utm_source=wpbackend&utm_medium=nexter-extension&utm_campaign=nextersettings',
            imgSrc: plugin_url + 'assets/images/uichemy.png',
            imgAlt: 'UiChemy Image',
            browseLink: '?page=uichemy-welcome',
            wdadded: nxtext_ajax_object.dashData.uichemy,
        },
        {
            key : 'the-plus-addons-for-elementor-page-builder',
            heading: __('Best Elementor Addon with 120+', 'nexter-extension'),
            subheading: __('Widgets', 'nexter-extension'),
            buttonLabel: __('Enable Addon', 'nexter-extension'),
            buttonLinkLabel: __('Open Addon', 'nexter-extension'),
            learnLink: 'https://theplusaddons.com/?utm_source=wpbackend&utm_medium=nexter-extension&utm_campaign=nextersettings',
            imgSrc: plugin_url + 'assets/images/tpae-addon.png',
            imgAlt: 'TPAE Image',
            browseLink: '?page=theplus_welcome_page',
            wdadded: nxtext_ajax_object.dashData.tpaeAddon,
        },
    ];    

    if( !nxtext_ajax_object.dashData.tpgbinstall ){
        slides.push(
            {   
                key : 'the-plus-addons-for-block-editor',
                heading: __('90+ Best WordPress Blocks for', 'nexter-extension'),
                subheading: __('Gutenberg Editor', 'nexter-extension'),
                buttonLabel: __('Enable Blocks', 'nexter-extension'),
                buttonLinkLabel: __('Open Blocks', 'nexter-extension'),
                learnLink: 'https://nexterwp.com/?utm_source=wpbackend&utm_medium=nexter-extension&utm_campaign=nextersettings',
                imgSrc: plugin_url + 'assets/images/nexter-blocks.png',
                imgAlt: 'Nexter Blocks Image',
                browseLink: '?page=nexter_welcome#/blocks',
                wdadded: nxtext_ajax_object.dashData.nexterBlock,
            },
        );
    }else if( !nxtext_ajax_object.dashData.extensioninstall ){
        slides.push(
            {
            key : 'nexter-extension',
            heading: __('50+ WordPress Extensions to Make Site More Secure, Performant & Smart', 'nexter-extension'),
            buttonLabel: __('Enable Extension', 'nexter-extension'),
            buttonLinkLabel: __('Open Extensions', 'nexter-extension'),
            learnLink: 'https://nexterwp.com/nexter-extension/?utm_source=wpbackend&utm_medium=blocks&utm_campaign=nextersettings',
            imgSrc: plugin_url + 'assets/images/nexter-exten.png',
            imgAlt: __('Nexter Extension'),
            browseLink: '?page=nexter_welcome',
            wdadded: nxtext_ajax_object.dashData.nexterext,
        });
    }else if( nxtext_ajax_object.dashData.nextheme === false ){
        slides.push(    
            {
                key : 'nexter-theme',
                heading: __('Lightest Starter Theme for Page Builders', 'nexter-extension'),
                buttonLabel: __('Install Theme', 'nexter-extension'),
                buttonLinkLabel: __('Open Theme Settings', 'nexter-extension'),
                learnLink: 'https://nexterwp.com/nexter-theme/?utm_source=wpbackend&utm_medium=blocks&utm_campaign=nextersettings',
                imgSrc: plugin_url + 'assets/images/nexter-theme.png',
                imgAlt: __('Nexter Theme Image'),
                browseLink: '?page=wdesign-kit#/browse',
                wdadded: nxtext_ajax_object.dashData.nextheme,
            },
        );
    }

    const getFeedData = async () => {
        
        if (isLoading || !hasMore || items.length > 0) return;

        setIsLoading(true);

        try {
            const response = await fetch(nxtext_ajax_object?.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'nxtext_fetch_whats_new',
                    nexter_nonce: nxtext_ajax_object.ajax_nonce,
                //    offset: offset.toString()
                })
            });

            const result = await response.json();

            if (result.success && result.data.length > 0) {
                setItems(prev => [...prev, ...result.data]);
            //    setOffset(prev => prev + result.data.length);
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error('Error loading RSS:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {

        if(openSidebar && items.length === 0){
            getFeedData();
        }else{
            /* const container = scrollRef.current;

            const handleScroll = () => {
            if (
                container.scrollTop + container.clientHeight >= container.scrollHeight - 50 &&
                !isLoading && hasMore
            ) {
                getFeedData(); // only call if not loading
            }
            };

            container.addEventListener('scroll', handleScroll);
            return () => container.removeEventListener('scroll', handleScroll); */
        }
        
    }, [openSidebar, isLoading, hasMore, items]);

    const blockList = nxtext_ajax_object.dashData.blockList;
    const totalBlock = blockList ? Object.values(blockList).filter(
        (item) => item?.block_cate !== 'WDesignKit'
    ).length : 90;

    const actBlock = nxtext_ajax_object?.dashData?.avtiveBlock || 0;

    return (
        <div className='nxtext_dashboard_inner_main nxtext_main_container'>
            <div className='nxtext_section_heading_cover'>
                <h3 className='nxtext_primary_heading'>{ __( 'Dashboard' , 'nexter-extension' ) }</h3>
            </div>

            <div className='nxtext_wlcm_section_cover'>
                <div className='nxtext_wlcm_section_inner'>
                    <div className='nxtext_user_img_with_name'>

                    {/* {nxtext_ajax_object.pro &&
                        <img className='nxtext_pro_icon' src={plugin_url + 'assets/svg/premium_icon.svg'} draggable={false} />
                    } */}
                    {/* { (nxtext_ajax_object.dashData && nxtext_ajax_object.dashData.userData) && */}
                        <>
                            <div className='nxt_user_img_cover'>
                                <img className='nxt_user_img' src={ nxtext_ajax_object.dashData.userData.profileLink ? nxtext_ajax_object.dashData.userData.profileLink : plugin_url + 'assets/images/dummy-profile.png'} draggable={false} />
                            </div>
                            <h3 className='nxt_user_name'>{nxtext_ajax_object.dashData.userData.userName ? nxtext_ajax_object.dashData.userData.userName : 'Welcome, UserName !'}</h3>
                        </> 
                    {/* } */}
                    </div>
                    { ((nxtext_ajax_object.dashData.tpgbinstall == '1' || nxtext_ajax_object.dashData.extensioninstall == '1') && !((nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && nxtext_ajax_object?.dashData?.whiteLabel?.nxt_plugin_news == 'on')) &&
                        <a className='nxtext_whats_new nxtext_primary_btn' onClick={() => {setSlideLeft(true),getFeedData()}}>{ __( "What's New?" , 'nexter-extension' ) }</a>
                    }
                </div>
 
                <div className='nxtext_statistics_and_form_section'>
                    <div className='nxtext_numinfo_wdk_qiklink_cover'>
                        <div className='nxtext_numinfo_cover'>
                            <div className='nxtext_numeric_crd'>
                                <div className='nxtext_numbers'>
                                    <span> { __( '90+', 'nexter-extension' ) } </span>
                                    <div className="nxt_category_quick_info"><span className="nxt_total_widget_numbers active"> {nxtext_ajax_object?.dashData?.nexterBlock == false ? __( 'Inactive' , 'nexter-extension' ) : actBlock + __( ' Active' , 'nexter-extension' ) } </span> </div>
                                </div>
                                <div className='nxtext_count'>{ __( 'Total Blocks' , 'nexter-extension' ) }</div>
                            </div>
                            <div className='nxtext_numeric_crd'>
                                <div className='nxtext_numbers'>
                                    <span> { __( "50+", 'nexter-extension' ) } </span>
                                    <div className="nxt_category_quick_info"><span className="nxt_total_widget_numbers">{nxtext_ajax_object?.dashData?.extensioninstall == false ? __( 'Inactive' , 'nexter-extension' ) : __( '25 Active' , 'nexter-extension' ) }</span></div>
                                </div>
                                <div className='nxtext_count'>{ __( 'Total Extensions' , 'nexter-extension' ) }</div>
                            </div>
                        </div>
                        { !((nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && nxtext_ajax_object?.dashData?.whiteLabel?.nxt_plugin_ads == 'on') &&
                            <div className='nxtext_product_slider'>
                                <Splide options={{ type: 'loop', autoplay: true, interval: 4000 , arrows :false }} >
                                    {slides.map((slide, index) => (
                                        <SplideSlide key={index}>
                                            <div className={`nxtext_wdesignkit_banner ${slide.key == 'the-plus-addons-for-elementor-page-builder' ? ' nxt-addon-slider' : ( slide.key == 'uichemy' ? ' nxt-uichemy-slider' : (slide.key == 'the-plus-addons-for-block-editor') ? 'nxt-block-slider' :' nxt-ext-wdesign' ) }`}>
                                                <div className='nxtext_wdk_left_content'>
                                                    <h3 className='nxtext_primary_heading nxtext_wdk_banner_h'>
                                                        {slide.heading}<br />{slide.subheading}
                                                    </h3>
                                                    <div className='nxtext_wdkit_btn_group'>
                                                        <>
                                                            { !slide.wdadded ? (
                                                                <button onClick={(e) => {installNxtPlugin(e, slide.key)} } className='nxtext_install_wdkit_btn'> {slide.buttonLabel} </button>
                                                            ) : (
                                                                <a href={slide.browseLink} target="_blank" rel="noopener noreferrer" className='nxtext_install_wdkit_btn'> {slide.buttonLinkLabel} </a>
                                                            )}
                                                        </>
                                                        <a className='nxtext_learn_btn_link' target="_blank" rel="noopener noreferrer" href={slide.learnLink}> { __('Learn More', 'nexter-extension') } </a>
                                                    </div>
                                                </div>
                                                <div className='nxtext_wdkit_right_content'>
                                                    <img className='nxtext_wdkit_right_img' src={slide.imgSrc} alt={slide.imgAlt} draggable={false} />
                                                </div>
                                            </div>
                                        </SplideSlide>
                                    ))}
                                </Splide>
                            </div>
                        }
                    </div>
                    { !((nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && nxtext_ajax_object?.dashData?.whiteLabel?.nxt_plugin_news == 'on') &&
                        <div className='nxtext_subscribe_form_cover'>
                            <h3 className='nxtext_primary_heading'>{ __( 'Stay Updated with Nexter & WordPress Updates' , 'nexter-extension' ) }.</h3>
                            <input
                                className='nxtext_subscribe_input_field'
                                type='text'
                                placeholder='Your Name'
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <input
                                className='nxtext_subscribe_input_field'
                                type='email'
                                placeholder='Your Email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <a className='nxtext_subscribe_btn' onClick={handleSubscribe}>{__('Subscribe Now', 'nexter-extension')}</a>
                            {error && <span className='nxtext_succ_message'>{error}</span>}
                            {success && <span className='nxtext_succ_message'>{success}</span>}
                        </div>
                    }
                </div>

            </div>
            { !((nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && nxtext_ajax_object?.dashData?.whiteLabel?.nxt_help_link == 'on') &&
                <div className='nxtext_qik_infocrd_cov_main'>
                    <div className='nxtext_qikinfo_crdgrp_cover'>
                        <div className='nxtext_qik_infobtn_crd_cover nxtext_docs'>
                            <h4 className='nxtext_primary_heading'>{ __( 'Documentation' , 'nexter-extension' ) }</h4>
                            <a target='_blank' rel="nofollow noopener noreferrer" href='https://nexterwp.com/docs/?utm_source=wpbackend&utm_medium=admin&utm_campaign=dashboardspage' className='nxtext_primary_btn'>{ __( 'Read Now' , 'nexter-extension' ) }</a>
                        </div>

                        <div className='nxtext_qik_infobtn_crd_cover nxtext_help'>
                            <h4 className='nxtext_primary_heading'>{ __( 'Need Help ?' , 'nexter-extension' ) }</h4>
                            <a target='_blank' rel="nofollow noopener noreferrer" href={ nxtext_ajax_object.pro ? 'https://store.posimyth.com/helpdesk/?utm_source=wpbackend&utm_medium=admin&utm_campaign=dashboardspage' : (nxtext_ajax_object.dashData.extensioninstall ? 'https://wordpress.org/support/plugin/nexter-extension/?utm_source=wpbackend&utm_medium=admin&utm_campaign=dashboardspage' : 'https://wordpress.org/support/plugin/the-plus-addons-for-block-editor/?utm_source=wpbackend&utm_medium=admin&utm_campaign=dashboardspage') } className='nxtext_primary_btn'>{ __( 'Raise Ticket' , 'nexter-extension' ) }</a>
                        </div>

                        <div className='nxtext_qik_infobtn_crd_cover'>
                            <h4 className='nxtext_primary_heading'>{ __( 'Join Community' , 'nexter-extension' ) }</h4>
                            <a target='_blank' rel="nofollow noopener noreferrer" href='https://www.facebook.com/groups/nexterwpcommunity/' className='nxtext_primary_btn'>{ __( 'Join Now' , 'nexter-extension' ) }</a>
                        </div>

                        <div className='nxtext_qik_infobtn_crd_cover'>
                            <h4 className='nxtext_primary_heading'>{ __( 'Request Feature' , 'nexter-extension' ) }</h4>
                            <a target='_blank' rel="nofollow noopener noreferrer" href='https://roadmap.nexterwp.com/boards/feature-requests?utm_source=wpbackend&utm_medium=admin&utm_campaign=dashboardspage' className='nxtext_primary_btn'>{ __( 'Suggest Now' , 'nexter-extension' ) }</a>
                        </div>


                    </div>

                    <div className='nxtext_qikinfo_crdgrp_cover'>

                        <div className='nxtext_qik_infobtn_crd_cover'>
                            <h4 className='nxtext_primary_heading'>{ __( 'Rate Nexter' , 'nexter-extension' ) }</h4>
                            <div className='nxtext_rating_box'>
                                {ratingSvg.map((obj, index) => (
                                    <a key={index} href={ ( index == 4 ? 'https://go.posimyth.com/rate-nexter-5' : 'https://go.posimyth.com/review-nexter' ) } target="_blank" rel="noopener noreferrer"  className='nxt-star' onMouseEnter={() => setHoveredIndex(index)} onMouseLeave={() => setHoveredIndex(null)}  onClick={() => setSelectedIndex(index)} > { obj.svg } </a>
                                ))}
                            </div>
                        </div>
                        <div className='nxtext_qik_infobtn_crd_cover'>
                            <h4 className='nxtext_primary_heading'>{ __( 'Join Discord' , 'nexter-extension' ) }</h4>
                            <a target="_blank" rel="noopener noreferrer" href="https://go.posimyth.com/nexter-discord" className='nxtext_primary_btn'>{ __( 'Join Now' , 'nexter-extension' ) }</a>
                        </div>
                        <div className='nxtext_qik_infobtn_crd_cover'>
                            <h4 className='nxtext_primary_heading'>{ __( 'Video Tutorials' , 'nexter-extension' ) }</h4>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/@posimyth?sub_confirmation=1" className='nxtext_primary_btn'>{ __( 'Watch Now' , 'nexter-extension' ) }</a>
                        </div>
                        <div className='nxtext_qik_infobtn_crd_cover nxtext_dash_social_crdbox'>
                            <h4 className='nxtext_primary_heading'>{ __( "We're Active on" , 'nexter-extension' ) }</h4>
                            <div className='nxtext_icon_box_cover'>
                                {icons.map((icon, index) => (
                                    <a href={icon.link} target="_blank" rel="noopener noreferrer" className='nxtext_icon_cover' key={index}>
                                        <img src={plugin_url + icon.path} draggable={false} alt={icon.name} />
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            }


            {/*---------------------------------- what's New Button Slider Start ---------------------------------- */}
            { (nxtext_ajax_object.dashData.tpgbinstall || nxtext_ajax_object.dashData.extensioninstall) &&
            <div className={slideLeft ? 'nxtext_whats_new_cover nxt_whats_new_box_opened' : 'nxtext_whats_new_cover nxtext_whatsnew_box_closed'} ref={scrollRef}>
                <div className='nxtext_heading_icon_strip'>
                    <h4 className='nxtext_primary_heading'>{ __( "What's New?" , 'nexter-extension' ) }</h4>
                    <img className='nxtext_whatsnew_closebtn' onClick={() => setSlideLeft(false)} src={plugin_url + 'assets/svg/dashboard_tab/close_icon.svg'} draggable={false} />
                </div>

                <ul className='nxtext_whatsnew_crdinfo_cover'>
                    {items.map((item, i) => (
                        <li className='whatnew-item' key={i}>
                            <div className='whatnew-tag-date'>
                                <div className='whatnew-tag'><span>{__('New')}</span></div>
                                <a href={item.link} target="_blank" rel="noopener noreferrer" className='whatnew-date'>{item.date}</a>
                            </div>
                            <a href={item.link} target="_blank" rel="noopener noreferrer"><h4 className='nxtext_primary_heading'>{decode(item.title)}</h4></a>
                            <a href={item.link} target="_blank" rel="noopener noreferrer" className='nxtext_whatsnew_imgcover'>
                                <img className='nxtext_whatsnew_img' src={item.image} draggable={false} ></img>
                            </a>
                            <p className='nxtext_secondary_heading' dangerouslySetInnerHTML={{ __html: item.desc }} />
                            <div className='nxtext_whats_new_btngrp'>
                                <a href={item.link} className='nxtext_whats_new_btnlink' target="_blank" rel="noopener noreferrer">{ __( 'Learn More' , 'nexter-extension' ) }</a>
                            </div>
                        </li>
                    ))}
                    {isLoading && <p className="text-center p-4"><svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" stroke="#1717CC" viewBox="0 0 38 38"><g fill="none" fillRule="evenodd" strokeWidth="2" transform="translate(1 1)"><circle cx="18" cy="18" r="18" strokeOpacity=".3"/><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" dur="1s" from="0 18 18" repeatCount="indefinite" to="360 18 18" type="rotate"/></path></g></svg></p>}
                    
                </ul>
                {items.length > 0 &&
                    <a href={"https://nexterwp.com/topic/product-announcements/extension"} className="nxtext_primary_btn" target="_blank" rel="noopener noreferrer">{ __( 'View More' , 'nexter-extension' ) }</a>
                }
            </div>
            }
            {/*---------------------------------- what's New Button Slider End ---------------------------------- */}
        </div>
    )
}
export default DashboardInnerMain;